import ar from "../languages/ar.json";
import bg from "../languages/bg.json";
import cs from "../languages/cs.json";
import da from "../languages/da.json";
import de from "../languages/de.json";
import el from "../languages/el.json";
import en from "../languages/en.json";
import en_GB from "../languages/en-GB.json";
import es from "../languages/es.json";
import es_MX from "../languages/es-MX.json";
import et from "../languages/et.json";
import fa from "../languages/fa.json";
import fi from "../languages/fi.json";
import fr from "../languages/fr.json";
import fr_CA from "../languages/fr-CA.json";
import he from "../languages/he.json";
import hi from "../languages/hi.json";
import hr from "../languages/hr.json";
import hu from "../languages/hu.json";
import hy from "../languages/hy.json";
import id from "../languages/id.json";
import it from "../languages/it.json";
import ja from "../languages/ja.json";
import ko from "../languages/ko.json";
import lt from "../languages/lt.json";
import lv from "../languages/lv.json";
import ms from "../languages/ms.json";
import nl from "../languages/nl.json";
import no from "../languages/no.json";
import pl from "../languages/pl.json";
import pt from "../languages/pt.json";
import pt_BR from "../languages/pt-BR.json";
import ro from "../languages/ro.json";
import ru from "../languages/ru.json";
import sk from "../languages/sk.json";
import sl from "../languages/sl.json";
import sr from "../languages/sr.json";
import sv from "../languages/sv.json";
import th from "../languages/th.json";
import tr from "../languages/tr.json";
import uk from "../languages/uk.json";
import vi from "../languages/vi.json";
import zh_CN from "../languages/zh-CN.json";
import zh_TW from "../languages/zh-TW.json";

const languages = {
    ar: ar,
    bg: bg,
    cs: cs,
    da: da,
    de: de,
    el: el,
    en: en,
    en_gb: en_GB,
    es: es,
    es_mx: es_MX,
    et: et,
    fa: fa,
    fi: fi,
    fr: fr,
    fr_ca: fr_CA,
    he: he,
    hi: hi,
    hr: hr,
    hu: hu,
    hy: hy,
    id: id,
    it: it,
    ja: ja,
    ko: ko,
    lt: lt,
    lv: lv,
    ms: ms,
    nl: nl,
    no: no,
    pl: pl,
    pt: pt,
    pt_br: pt_BR,
    ro: ro,
    ru: ru,
    sk: sk,
    sl: sl,
    sr: sr,
    sv: sv,
    th: th,
    tr: tr,
    uk: uk,
    vi: vi,
    zh_cn: zh_CN,
    zh_tw: zh_TW
};

export default languages;
